import React, { useState } from 'react'
import { FaRegFilePdf, FaDownload } from 'react-icons/fa'
import {
  onfsLinkStyle,
  onfsLinkStyleHovered
} from '../../branding/onfsLinkStyles'

import colors from '../../branding/colors'

export default function OnfsIconBtn({
  icon = '',
  label,
  labelVisible = false,
  style = {},
  ...rest
}) {
  const [isHovered, setIsHovered] = useState(false)
  const linkStyling = isHovered
    ? { ...style, ...onfsLinkStyle, ...onfsLinkStyleHovered }
    : { ...style, ...onfsLinkStyle }

  const baseIconStyle = {
    color: colors.primaryDark,
    paddingRight: '2pt',
    fontSize: `${style.fontSize || '14pt'}`
  }

  const iconStyling = isHovered
    ? { ...baseIconStyle, color: colors.dark }
    : baseIconStyle
  return (
    <button
      aria-label={label}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onFocus={() => setIsHovered(true)}
      onBlur={() => setIsHovered(false)}
      style={linkStyling}
      {...rest}
    >
      {icon === 'document' ? (
        <FaRegFilePdf style={iconStyling} />
      ) : icon === 'download' ? (
        <FaDownload style={iconStyling} />
      ) : null}
      {labelVisible ? label : null}
    </button>
  )
}
